<template>
  <div>
    <form-model :title="title" width="700" ref="formModel" :labelWidth="100">
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <createdFlow ref="createdFlow"></createdFlow>
  </div>
</template>
<script>
import fields from "./fields";
import createdFlow from "./createdFlow.vue";
export default {
  components: { createdFlow },
  data() {
    return {
      openForm: false,
      isAdd: true,
      forms: [],
      ruleValidate: {},
      item: {
        groupName: "",
        groupId: "",
        name: "横琴二桥",
        time: Date.now(),
        address: "横琴二桥",
        supervisor: "",
        approveFileList: [],
        handoverFileList: [],
        peopleNum: 1
      },
      title: "",
      flowId: "",
    };
  },
  methods: {
    reach(v) {
      this.forms = fields[v.field];
      this.title = v.name;
      this.serverUrl = v.serverUrl;
      this.flowId = v.flowId;
      this.formId = v.id;
      this.getUser();
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      this.axios({
        method: "post",
        url: this.serverUrl + "/add",
        data: this.item,
      }).then((res) => {
        if (res) {
          this.$refs.formModel.close();
          var data = res.data.data;
          var obj = {
            flowId: this.flowId,
            id: data.id,
            no: data.no,
            groupId: data.groupId,
            formId: this.formId,
          };
          this.$refs.createdFlow.reach(obj);
        }
      });
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },

    getUser() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: "/account/getUserItem",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        this.item.dispatcher = this.utils.text(data.name, "");
        this.$refs.formModel.reach(this.forms, this.item);
      });
    },
  },
  mounted() { },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/forms/gaoweizuoye.vue